import HttpService from '../../../common/http/HttpService';
import MasterDataEndpoint from '../const/MasterDataEndpoint';
import VcomProvider from '../../../VcomProvider';

function get() {
  const systemId = VcomProvider.adminSystemId;
  return HttpService.post(MasterDataEndpoint.GET, { systemId });
}

function getBySystemId(systemId) {
  return HttpService.post(MasterDataEndpoint.GET, { systemId });
}

function save(masterData) {
  return HttpService.post(MasterDataEndpoint.SAVE, masterData);
}

function saveSite(site) {
  const systemId = VcomProvider.adminSystemId;

  return HttpService.post(MasterDataEndpoint.SAVE_SITE, {
    systemId,
    title: site.title,
    description: site.description,
    form: JSON.stringify(site.form),
  });
}

function updateSite(site) {
  const systemId = VcomProvider.adminSystemId;
  const {
    form,
    id,
    title,
    description,
  } = site;

  return HttpService.post(MasterDataEndpoint.UPDATE_SITE, {
    id,
    title,
    description,
    systemId,
    form: JSON.stringify(form),
  });
}

async function loadForm(id) {
  const systemId = VcomProvider.adminSystemId;
  const response = await HttpService.post(MasterDataEndpoint.LOAD_SITE, { systemId, id });
  return response.data;
}

async function loadSitesMetaData() {
  const systemId = VcomProvider.adminSystemId;
  const response = await HttpService.post(MasterDataEndpoint.LOAD_SITES_META_DATA, { systemId });

  return response.data;
}

async function deleteSite(id) {
  const systemId = VcomProvider.adminSystemId;
  const response = await HttpService.post(MasterDataEndpoint.DELETE_SITE, { systemId, id });

  return response.data;
}

function updateElement(addedElements, newElement) {
  return addedElements.map((addedElement) => {
    if (addedElement.id === newElement.id) {
      return newElement;
    }
    return addedElement;
  });
}

const MasterDataService = {
  get,
  getBySystemId,
  save,
  saveSite,
  updateSite,
  loadForm,
  loadSitesMetaData,
  deleteSite,
  updateElement,
};

export default MasterDataService;
